<template>
  <div class="wrapper" @click="tabClick">
    <div v-if="isShowCancelPush" class="elect l_flex_row_center">
      <span class="iconfont icon-icon_dianzan"></span>
      <span>本馆推选</span>
    </div>
    <!-- <img :src="cover" class="cover" alt="" /> -->
    <el-image
      class="cover"
      :src="cover"
      :lazy="true"
      fit="cover"></el-image>
    <div class="content">
      <h5 class="title">{{ obj.name }}</h5>
      <p class="author">作者：{{ obj.username }}</p>
      <p class="author">选送机构：{{ obj.from }}</p>
      <div class="icons l_flex_row">
        <div class="icon l_flex_row_center">
          <i class="iconfont icon-good"></i>
          <div class="nub">{{ obj.mark }}</div>
        </div>
        <div class="icon l_flex_row_center">
          <i class="iconfont icon-browse"></i>
          <div class="nub">{{ obj.views }}</div>
        </div>
      </div>
      <!-- <div class="bottom l_flex_row">
        <p>推荐</p>
        <p>选送</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    cover() {
      return this.obj.image[0];
    },
    // 是否显示取消推选按钮
    isShowCancelPush() {
      if ( this.obj.is_push == true) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    tabClick() {
      // this.$message.closeAll();
      // this.$message({
      //   message: "type==" + this.obj.type,
      //   type: "info",
      // });

      this.$router.push({
        path: "/workdetail",
        query: {
          type: this.obj.activity_type,
          id: this.obj.id
        },
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background-color: #fff;
  border: 1px solid #eeeeee;
  position: relative;
  .cover {
    background-color: #815a4e;
    height: 260px;
    width: 100%;
    object-fit: cover;
  }
  .elect {
      font-size: 14px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 38px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      .iconfont {
        margin-right: 4px;
      }
    }
  .content {
    padding: 16px;
    box-sizing: border-box;
    p {
      margin: 0;
    }
    .title {
      margin: 0;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 14px;
      @include text-dot();
    }
    .author {
      font-size: 12px;
      color: #999999;
      line-height: 24px;
      @include text-dot();
    }
    .icons {
      color: #999999;
      font-size: 14px;
      margin: 20px 0;
      .icon {
        margin-right: 10px;
        cursor: pointer;
        .nub {
          margin-left: 4px;
        }
      }
    }
    .bottom {
      font-size: 15px;
      color: #815a4e;
      cursor: pointer;
      p {
        position: relative;
        margin-right: 24px;
        &:nth-child(1)::before {
          content: "";
          display: block;
          position: absolute;
          right: -12px;
          background-color: #815a4e;
          height: 20px;
          width: 1px;
        }
      }
    }
  }
}
</style>
